import { usePartnerConfig } from '~/stores/usePartnerConfig';
import { useCustomTariffStore } from "~/stores/useCustomTariffStore";

export default defineNuxtPlugin(async (nuxtApp) => {
  const { getPartnerConfig, config } = usePartnerConfig();
  const { getUnlimTariffs, getPromiseTariffs } = useCustomTariffStore();

  await getPartnerConfig();

  const promises = [
    getUnlimTariffs(),
    getPromiseTariffs(),
  ];

  await Promise.all(promises);
});
